import rootSaga from "@store/rootSaga";
import { sagaMiddleware, store } from "@store/store";

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;

export { store, persistor } from "@store/store";
